   
                        
  
                                                  
                          
   

import Utilities from '../util/utilities';
import Dispatcher from './dispatcher';

   
                   
   
export default class Observer {
     
                
    
                             
                                   
     
  constructor (value, dispatcher) {
    this.value = value;
    this.dispatcher = dispatcher;

    Utilities.define(value, '__observer__', this, false);
  }
}

const hasProto = '__proto__' in {};
const arrayProto = Array.prototype;
const replaceMethods = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

export class ObserverFactory {
     
                
    
                             
     
  constructor (app) {
    this.app = app;
  }

     
                            
    
                     
    
                           
     
  create (value) {
    if (!Utilities.isObject(value)) {
      return null;
    }

    let observer;

    if (!value.hasOwnProperty('__observer__') && value.__observer__ instanceof Observer) {
      observer = value.__observer__;
    } else if (Array.isArray(value)) {
      observer = new Observer(value, new Dispatcher(this.app));

      this.replaceArrayMethods(value);

      value.forEach(val => this.create(val));
    } else if (Utilities.isPlainObject(value) && Object.isExtensible(value)) {
      observer = new Observer(value, new Dispatcher(this.app));

      Object.keys(value).forEach((key) => this.reactive(value, key, value[key]));
    }

    return observer;
  }

     
                                             
    
                           
                        
                          
    
                 
     
  set (object, key, value) {
    if (Array.isArray(object)) {
      object.length = Math.max(object.length, key);
      object.splice(key, 1, value);
      return value;
    }

    if (Utilities.has(object, key)) {
      object[key] = value;
      return value;
    }

    const ob = object.__observer__;
    if (!ob) {
      ob[key] = value;
      return value;
    }

    this.reactive(object, key, value);
    ob.dispatcher.notify();
    return value;
  }

     
                     
    
                           
                        
     
  delete (object, key) {
    if (Array.isArray(object)) {
      object.splice(key, 1);
      return;
    }

    const ob = object.__observer__;

    if (!Utilities.has(object, key)) {
      return;
    }

    delete object[key];

    if (!ob) {
      return
    }

    ob.dispatcher.notify();
  }

     
                           
    
                                                                                       
                                                                 
    
                           
                        
                          
     
  reactive (object, key, value) {
    const property = Object.getOwnPropertyDescriptor(object, key);
    const dispatcher = new Dispatcher(this.app);
    const self = this;

    if (property && property.configurable === false) {
      return;
    }

    const getter = property && property.get;
    const setter = property && property.set;

    let childObserver = this.create(value);

    Object.defineProperty(object, key, {
      get: function () {
        value = getter ? getter.call(object) : value;

          
                                                                                                  
                                                          
           
        if (self.app.currentWatcher) {
          self.app.currentWatcher.addDispatcher(dispatcher);

                                                                                      
          if (childObserver) {
            self.app.currentWatcher.addDispatcher(childObserver.dispatcher);
          }

          if (Array.isArray(value)) {
            self.attachArray(value);
          }
        }

        return value;
      },
      set: function (newValue) {
        const oldValue = getter ? getter.call(object) : value;

        if (newValue === oldValue || (newValue !== newValue && oldValue !== oldValue)) {
          return;
        }

        if (setter) {
          setter.call(object, newValue);
        } else {
          value = newValue;
        }

        childObserver = self.create(newValue);

        dispatcher.notify();
      }
    });
  }

     
                             
                         
     
  attachArray (value = []) {
    for (let key in value) {
      const ele = value[key];
      ele && ele.__observer__ && this.app.currentWatcher.addDispatcher(ele.__observer__.dispatcher);

      if (Array.isArray(ele)) {
        this.attachArray(ele);
      }
    }
  }

     
                                            
                         
                     
     
  replaceArrayMethods (value) {
    const self = this;
    const arrayMethods = Object.create(arrayProto);

    replaceMethods.forEach(function (method) {
                              
      const original = arrayProto[method];

      Utilities.define(arrayMethods, method, function mutator () {
        let i = arguments.length;
        const args = new Array(i);

        while (i--) {
          args[i] = arguments[i]
        }

        const result = original.apply(this, args);
        const ob = this.__observer__;

        let inserted;

        switch (method) {
          case 'push':
            inserted = args;
            break;
          case 'unshift':
            inserted = args;
            break;
          case 'splice':
            inserted = args.slice(2);
            break;
        }

        if (inserted) {
          self.create(inserted);
        }

                        
        ob.dispatcher.notify({
          method: method,
          args: args
        });

        return result;
      });
    });

    if (hasProto) {
      value.__proto__ = arrayMethods;
      return value;
    }

    arrayMethods.forEach((method, key) => Utilities.define(value, key, method));
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/observer/observer.js